<template>
  <v-dialog
    :value="errorModal.show"
    max-width="600"
    persistent
    @input="closeModal"
  >
    <v-card>
      <v-card-title class="red lighten-1 white--text">
        <v-icon left dark>mdi-alert-circle</v-icon>
        {{ errorModal.title || 'Error' }}
      </v-card-title>

      <v-card-text class="pt-4">
        <p class="mb-3">{{ errorModal.message }}</p>

        <div v-if="errorModal.details" class="mt-4">
          <div class="text-subtitle2 mb-3 font-weight-bold">Error Details:</div>

          <!-- Handle array of errors -->
          <div v-if="Array.isArray(errorModal.details)" class="error-sections">
            <div
              v-for="(error, index) in errorModal.details"
              :key="index"
              class="error-section mb-3"
            >
              <div class="error-content">
                <div v-if="error.error">{{ error.error }}</div>
                <div v-if="error.url" class="mt-2">
                  <a :href="error.url" target="_blank" class="text-primary">
                    <span>Check settings</span>
                  </a>
                </div>
                <div v-if="!error.error && !error.url">
                  {{ formatSingleError(error) }}
                </div>
              </div>
            </div>
          </div>

          <!-- Handle single error -->
          <div v-else class="error-content">
            {{ formatSingleError(errorModal.details) }}
          </div>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" text @click="closeModal"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ErrorModal',

  computed: {
    ...mapGetters(['errorModal']),
  },

  methods: {
    ...mapActions(['closeErrorModal']),
    closeModal() {
      this.closeErrorModal()
    },
    formatSingleError(error) {
      if (typeof error === 'string') {
        return error
      }

      if (typeof error === 'object') {
        try {
          return JSON.stringify(error, null, 2)
        } catch (e) {
          return String(error)
        }
      }

      return String(error)
    },
  },
}
</script>

<style lang="scss" scoped>
.error-sections {
  .error-section {
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.error-content {
  background-color: #f8f9fa;
  border-left: 3px solid #e9ecef;
  padding: 12px;
  border-radius: 4px;
  font-family: 'Roboto Mono', monospace;
  font-size: 14px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
